import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

const LetDiscuss = () => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://vidhaninfotech.com/smtptester/mailsend.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Good job!",
          text: "We received your request, We will respond soon!",
          icon: "success",
        });
        setLoading(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        setLoading(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      setLoading(false);
    }
  };
  return (
    <section className="letDiscuss">
      <div className="container">
        <div className="appdevelopment_header_content">
          <h2>
            Let&apos;s <span>discuss</span> Your Project
          </h2>
        </div>
        <div className="letDiscussForm">
          <form className="row" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-md-4">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Your Name"
                  className="form-control"
                  {...register("name", { required: "Name is required" })}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Work Email Address"
                  className="form-control"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Enter a valid email",
                    },
                  })}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Subject"
                  className="form-control"
                  {...register("subject", { required: "Subject is required" })}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <textarea
                  rows="5"
                  placeholder="Describe Your Requirement"
                  className="form-control"
                  {...register("message", { required: "Message is required" })}
                ></textarea>
              </div>
            </div>
            <div className="col-md-12">
              <input
                type="submit"
                className={`px-4 py-2 theme_btn`}
                value={loading ? "Loading..." : "Inquire Now"}
              />
              {/* <button className="theme_btn">
                  <span>Inquire Now</span>
                </button> */}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default LetDiscuss;
